import { DOCUMENT } from '@angular/common';
import {
  ApplicationRef,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  Inject,
  Injector,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { NgbTooltip, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { Placement } from '@ng-bootstrap/ng-bootstrap/util/positioning';
import { TypedChanges } from '@platform-frontend/util';

@Directive({
  selector: '[yatTooltip]',
  exportAs: 'yatTooltip'
})
export class TooltipDirective implements OnInit, OnChanges, OnDestroy {
  constructor(
    elementRef: ElementRef<HTMLElement>,
    renderer: Renderer2,
    injector: Injector,
    viewContainerRef: ViewContainerRef,
    config: NgbTooltipConfig,
    ngZone: NgZone,
    @Inject(DOCUMENT) document: Document,
    changeDetector: ChangeDetectorRef,
    applicationRef: ApplicationRef
  ) {
    this.ngbTooltip = new NgbTooltip(elementRef, renderer, injector, viewContainerRef, config, ngZone, document, changeDetector, applicationRef);
  }

  ngbTooltip: NgbTooltip;

  @Input('yatTooltip')
  content: string | TemplateRef<any> | null;

  @Input()
  disableTooltip: boolean;

  @Input()
  tooltipClass: string;

  @Input()
  tooltipPlacement: Placement[];

  @Input()
  centerPlacements: boolean;

  @Input()
  manualTooltip: boolean;

  @Input()
  appendToBody: boolean;

  readonly centeredPlacements: Placement[] = ['top', 'bottom', 'left', 'right'];

  open(): void {
    this.ngbTooltip.open();
  }

  close(): void {
    this.ngbTooltip.close();
  }

  ngOnInit(): void {
    this.ngbTooltip.ngOnInit();
  }

  ngOnChanges(changes: TypedChanges<TooltipDirective>): void {
    if (changes.content) {
      this.ngbTooltip.ngbTooltip = this.content;
    }
    if (changes.disableTooltip) {
      this.ngbTooltip.disableTooltip = this.disableTooltip;
    }
    if (changes.tooltipClass) {
      this.ngbTooltip.tooltipClass = this.tooltipClass;
    }
    if (changes.tooltipPlacement) {
      this.ngbTooltip.placement = this.centerPlacements ? this.getCenterFilteredTooltipPlacements() : this.tooltipPlacement;
    }
    if (changes.centerPlacements) {
      this.ngbTooltip.placement = this.tooltipPlacement ? this.getCenterFilteredTooltipPlacements() : this.centeredPlacements;
    }
    if (changes.manualTooltip) {
      this.ngbTooltip.triggers = this.manualTooltip ? 'manual' : 'hover focus';
    }
    if (changes.appendToBody) {
      this.ngbTooltip.container = 'body';
    }
  }

  ngOnDestroy(): void {
    this.ngbTooltip.ngOnDestroy();
  }

  private getCenterFilteredTooltipPlacements(): Placement[] {
    return this.tooltipPlacement?.filter(p => this.isPlacementCentered(p));
  }

  private isPlacementCentered(placement: Placement): boolean {
    return this.centeredPlacements.indexOf(placement) !== -1;
  }
}
